export const decodeJwtToken = (token) => {
  if (!token) {
    return null;
  }

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding JWT token:', error);
    return null;
  }
};

export const extractRolesFromToken = (token) => {
  const decoded = decodeJwtToken(token);
  if (!decoded) {
    return [];
  }

  // Azure AD roles can be in different claim types
  const roles = decoded.roles || decoded.Roles || decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] || [];

  // Handle both array and single string formats
  return Array.isArray(roles) ? roles : [roles];
};
